import React from 'react';

class DayNames extends React.Component {

    render() {
        return (
            <div className="days-header">
    			<span className="day week-nr"></span>
        		<span className="day">Mon</span>
    			<span className="day">Tue</span>
    			<span className="day">Wed</span>
    			<span className="day">Thu</span>
    		   	<span className="day">Fri</span>
    		   	<span className="day">Sat</span>
    			<span className="day">Sun</span>
    		</div>
        );
    }
}
export default DayNames;



/** WEBPACK FOOTER **
 ** ./app/src/components/Calendar/DayNames.js
 **/